/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { UniversalProductsCategory } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsTreeResponse';
import { getExplodedUniversalProductsTreeItem, resetUniversalProductsFilters } from 'domains/catalog/Catalog.store';
import { getCatalogSourceUrl, useCatalogSourceLocation } from 'domains/catalog/Catalog.utils';
import { Breadcrumb } from 'UI';

const hasChildCategories = (category: UniversalProductsCategory | undefined) =>
  (category?.childCategories?.length ?? 0) > 0;

const ProductsBreadcrumb = ({ tree }: { tree: UniversalProductsCategory[] | undefined }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { level1, level2, level3 } = useParams<{
    level1: string;
    level2: string;
    level3: string;
  }>();

  const catalogSource = useCatalogSourceLocation();
  const catalogSourceUrl = getCatalogSourceUrl(catalogSource);

  const categoryLvl1 = getExplodedUniversalProductsTreeItem(tree, [level1]);
  const categoryLvl2 = getExplodedUniversalProductsTreeItem(tree, [level1, level2]);
  const categoryLvl3 = getExplodedUniversalProductsTreeItem(tree, [level1, level2, level3]);

  const resetFilter = () => {
    dispatch(resetUniversalProductsFilters());
    history.replace({
      pathname: location.pathname,
      search: '',
    });
  };

  const getLevel2Link = () =>
    hasChildCategories(categoryLvl2) ? `${catalogSourceUrl}/${level1}` : `${catalogSourceUrl}/${level1}/${level2}`;

  const getBreadcrumbItems = () => {
    const breadcrumbItems = [
      {
        link: '/',
        label: t('common.home', 'Home'),
      },
    ];
    if (level1 && categoryLvl1) {
      breadcrumbItems.push({
        link: `${catalogSourceUrl}/${level1}`,
        label: categoryLvl1.name ?? '',
      });
    }
    if (level2 && categoryLvl2) {
      breadcrumbItems.push({
        link: getLevel2Link(),
        label: categoryLvl2.name ?? '',
      });
    }
    if (level3 && categoryLvl3) {
      breadcrumbItems.push({
        link: `${catalogSourceUrl}/${level1}/${level2}/${level3}`,
        label: categoryLvl3.name ?? '',
      });
    }
    return breadcrumbItems;
  };

  return <Breadcrumb items={getBreadcrumbItems()} onClickItem={resetFilter} />;
};

export default ProductsBreadcrumb;
